export default "__VITE_ASSET__CTjHG$7i__"